module.exports = __webpack_public_path__ + "img/logo-wide-black.2aad4157.png";